import { formatDateToMMDDYYYY, routeNavigationUrl } from 'helpers/util-common';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Icon, Modal } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import TextArea from 'shared-components/TextArea';
import ReduxCheckboxElement from 'shared-components/CheckBox/redux-checkbox';
import DateTimeForm from 'shared-components/DatePicker';
import * as common from 'helpers/util-common';
import CustomConfirmModal from 'shared-components/CustomAlertModal/CustomConfirmModal';
import { Form } from 'semantic-ui-react';
import * as utilCommon from 'helpers/util-common';

class MemberCommitteeOfficerTitleHistoryModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            CommitteeMemberOfficerTitleLogId: 0,
            isEdit: false,
            isShowOfficerTitleArchievePopup: false,
            isArchive: false,
            OfficerAppointedDate: '',
            OfficerEndDate: '',
            minDate: '01/02/1900',
            currentDate: utilCommon.formatDateToMMDDYYYY()
        }
    }

    render() {
        const { onCloseMemberCommitteeOfficerTitleHistoryModal,openMemberCommitteeOfficerTitleHistoryModal,
            memberCommitteeOfficerTitleHistoryList, hasUserPageAccess,
            PAGE_TYPE, USER_PRIVILEGE, handleSubmit, submitting,getMemberMainSubCommittees,
            memberCommitteeDetails, committeeStatus, memberStatus,
            previousOfficerAppointedDate, previousOfficerEndDate, nextOfficerAppointedDate,
            nextOfficerEndDate, setOfficerDetails, currentOfficerEndDate,
            hasEditMemberParticipationOnCommittees } = this.props;
        const { CommitteeMemberOfficerTitleLogId, isEdit,
            OfficerAppointedDate, OfficerEndDate, isArchive, minDate, currentDate } = this.state;

        const onEditClick = (CommitteeMemberOfficerTitleLogId, OfficerAppointedDate, OfficerEndDate) => {
            this.setState({
                CommitteeMemberOfficerTitleLogId, OfficerAppointedDate: OfficerAppointedDate,
                OfficerEndDate: OfficerEndDate, isEdit: true
            });
            let previousOfficer = memberCommitteeOfficerTitleHistoryList.filter(x => x.CommitteeMemberOfficerTitleLogId < CommitteeMemberOfficerTitleLogId);
            let nextOfficer = memberCommitteeOfficerTitleHistoryList.filter(x => x.CommitteeMemberOfficerTitleLogId > CommitteeMemberOfficerTitleLogId);
            let previousOfficerAppointedDate = '';
            let previousOfficerEndDate = '';
            let nextOfficerAppointedDate = '';
            let nextOfficerEndDate = '';
            if (previousOfficer.length > 0) {
                previousOfficerAppointedDate = previousOfficer[0]?.OfficerAppointedDate ?
                    utilCommon.formatDateToMMDDYYYY(previousOfficer[0]?.OfficerAppointedDate) : '';
                previousOfficerEndDate = previousOfficer[0]?.OfficerEndDate ?
                    utilCommon.formatDateToMMDDYYYY(previousOfficer[0]?.OfficerEndDate) : '';
            }
            if (previousOfficer.length > 0 && nextOfficer.length > 0) {
                nextOfficerAppointedDate = nextOfficer[0]?.OfficerAppointedDate ?
                    utilCommon.formatDateToMMDDYYYY(nextOfficer[0]?.OfficerAppointedDate) : '';
                nextOfficerEndDate = nextOfficer[0]?.OfficerEndDate ?
                    utilCommon.formatDateToMMDDYYYY(nextOfficer[0]?.OfficerEndDate) : '';
            }
            if (previousOfficer.length == 0 && nextOfficer.length > 0) {
                nextOfficerAppointedDate = nextOfficer[nextOfficer.length - 1]?.OfficerAppointedDate ?
                    utilCommon.formatDateToMMDDYYYY(nextOfficer[nextOfficer.length - 1]?.OfficerAppointedDate) : '';
                nextOfficerEndDate = nextOfficer[nextOfficer.length - 1]?.OfficerEndDate ?
                    utilCommon.formatDateToMMDDYYYY(nextOfficer[nextOfficer.length - 1]?.OfficerEndDate) : '';
            }
            setOfficerDetails(previousOfficerAppointedDate, previousOfficerEndDate, nextOfficerAppointedDate, nextOfficerEndDate, OfficerEndDate);
            this.props.change('OfficerAppointedDate', OfficerAppointedDate);
            this.props.change('OfficerEndDate', OfficerEndDate);
        }

        const onCancelEditClick = () => {
            this.setState({ CommitteeMemberOfficerTitleLogId: 0, isEdit: false, OfficerAppointedDate: '', OfficerEndDate: '', isArchive: false });
            setOfficerDetails('', '', '', '', '');
            this.props.change('OfficerAppointedDate', '');
            this.props.change('OfficerEndDate', '');
            this.props.change('ArchiveDetails', false);
        }

        const onArchiveDetailsChange = (value) => {
            if (value) {
                this.setState({ isShowOfficerTitleArchievePopup: true, isArchive: false });
            }
            else {
                this.setState({ isArchive: false });
            }
        }

        const onCancelBtnArchivePopup = () => {
            this.setState({ isShowOfficerTitleArchievePopup: false, isArchive: false });
            this.props.change('ArchiveDetails', false);
        }

        const onConfirmBtnArchivePopup = () => {
            this.setState({ isShowOfficerTitleArchievePopup: false, isArchive: true });
        }

        const onOfficerAppointedDateChange = (value) => {
            this.setState({ OfficerAppointedDate: value });
        }

        const onOfficerEndDateChange = (value) => {
            this.setState({ OfficerEndDate: value });
        }

        const submitForm = (values) => {
            const { CommitteeMemberOfficerTitleLogId, OfficerAppointedDate,
                OfficerEndDate, isArchive
            } = this.state;
            let postData = {
                CommitteeMemberOfficerTitleLogId: CommitteeMemberOfficerTitleLogId,
                OfficerAppointedDate: OfficerAppointedDate,
                OfficerEndDate: OfficerEndDate,
                ReasonForUpdate: values?.updateReason,
                IsArchive: isArchive,
                Officers: this.props?.officerTitleList,
                AccountNumber: this.props?.AccountNumber
            }
            if (values?.updateReason) {
                this.props.updateUpdateOfficerHistory(postData, response => {
                    if (response) {
                        this.setState({ CommitteeMemberOfficerTitleLogId: 0, isEdit: false, OfficerAppointedDate: '', OfficerEndDate: '', isArchive: false });
                        setOfficerDetails('', '', '', '', '');
                        onCloseMemberCommitteeOfficerTitleHistoryModal();
                        getMemberMainSubCommittees();
                    }
                });
            }
        }

        return (
            <Fragment>
                <Modal open='true'>
                    <Modal.Header>Officer History Details <i className="close" data-testid="close" onClick={onCloseMemberCommitteeOfficerTitleHistoryModal}>&#x2716;</i></Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={''} noValidate>
                                <div className="tableWrapper">
                                    <table className="customTable memComHistoryTable">
                                        <thead>
                                            <tr>
                                                <th width="20%">Officer Title</th>
                                                <th width="25%">Officer Appointed Date</th>
                                                <th width="20%">Officer End Date</th>
                                                <th width="20%">Updated Date</th>
                                                <th width="15%">Updated By</th>
                                                {hasEditMemberParticipationOnCommittees && <th width="15%">Action</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {memberCommitteeOfficerTitleHistoryList && memberCommitteeOfficerTitleHistoryList.length > 0 &&
                                                memberCommitteeOfficerTitleHistoryList.map((item) => {
                                                    return (
                                                        <Fragment>
                                                            <tr>
                                                                <td width="20%">{item.OfficerTitleName}</td>
                                                                <td width="45%" colSpan="2">
                                                                    <div className='datePickerRow'>
                                                                        <div className="appointed-date">
                                                                            {
                                                                                isEdit && CommitteeMemberOfficerTitleLogId == item.CommitteeMemberOfficerTitleLogId ?
                                                                                    <Field
                                                                                        name="OfficerAppointedDate"
                                                                                        dataTestId="OfficerAppointedDate"
                                                                                        component={DateTimeForm} label="Officer Appointed Date"
                                                                                        value={OfficerAppointedDate}
                                                                                        showTime={false}
                                                                                        required={true}
                                                                                        initialDate={OfficerAppointedDate}
                                                                                        maxDate={currentDate}
                                                                                        minDate={minDate}
                                                                                        normalize={common.dateMasking}
                                                                                        onChange={onOfficerAppointedDateChange}
                                                                                        readOnly={false}
                                                                                        disabled={isArchive}
                                                                                    />
                                                                                    :
                                                                                    formatDateToMMDDYYYY(item.OfficerAppointedDate)}
                                                                        </div>
                                                                        <div className='officer-end-date'>
                                                                            {
                                                                                isEdit && CommitteeMemberOfficerTitleLogId == item.CommitteeMemberOfficerTitleLogId ?
                                                                                    <Field
                                                                                        name="OfficerEndDate"
                                                                                        dataTestId="OfficerEndDate"
                                                                                        component={DateTimeForm} label="Officer End Date"
                                                                                        value={OfficerEndDate}
                                                                                        showTime={false}
                                                                                        required={true}
                                                                                        initialDate={OfficerEndDate}
                                                                                        maxDate={currentDate}
                                                                                        minDate={minDate}
                                                                                        normalize={common.dateMasking}
                                                                                        onChange={onOfficerEndDateChange}
                                                                                        readOnly={false}
                                                                                        disabled={isArchive}
                                                                                    />
                                                                                    : item.OfficerEndDate ? formatDateToMMDDYYYY(item.OfficerEndDate) : item.OfficerEndDate}
                                                                        </div>
                                                                    </div></td>
                                                                <td width="20%">{formatDateToMMDDYYYY(item.UpdatedDate)}</td>
                                                                <td width="15%">
                                                                    {hasUserPageAccess && Number(item.UpdatedBy) > 0 ? (<Link target="_blank" to={`${routeNavigationUrl(PAGE_TYPE.DETAIL(PAGE_TYPE.USER), USER_PRIVILEGE.VIEW, [item.UpdatedBy])}`}>{item.UpdatedUserName}</Link>) : <span>{item.UpdatedUserName}</span>}
                                                                </td>
                                                                {hasEditMemberParticipationOnCommittees &&
                                                                    <td width="15%">
                                                                        <ul className="editDetailsBtn">
                                                                            {isEdit && CommitteeMemberOfficerTitleLogId == item.CommitteeMemberOfficerTitleLogId ?
                                                                                <Fragment>
                                                                                    <li>
                                                                                        <button title="Update" className="updateBtn" type="button" disabled={submitting} onClick={handleSubmit(submitForm)}>
                                                                                            <Icon name="check" />
                                                                                        </button>
                                                                                    </li>
                                                                                    <li>
                                                                                        <button title="Cancel" className="closeBtn" onClick={onCancelEditClick}>
                                                                                            <Icon name="close" />
                                                                                        </button>
                                                                                    </li>
                                                                                </Fragment>
                                                                                :
                                                                                <li>
                                                                                    <button title="Edit" className="editBtn" type="button" disabled={''} onClick={() => onEditClick(item.CommitteeMemberOfficerTitleLogId,
                                                                                        utilCommon.formatDateToMMDDYYYY(item.OfficerAppointedDate), item.OfficerEndDate ?
                                                                                        utilCommon.formatDateToMMDDYYYY(item.OfficerEndDate) : '')}>
                                                                                        <Icon name='pencil' />
                                                                                    </button>
                                                                                </li>
                                                                            }
                                                                        </ul>
                                                                    </td>
                                                                }
                                                            </tr>
                                                            {isEdit && CommitteeMemberOfficerTitleLogId == item.CommitteeMemberOfficerTitleLogId &&
                                                                <tr>
                                                                    <td width="60%">
                                                                        <Field name="updateReason" type="text"
                                                                            component={TextArea} required={true}
                                                                            label="Reason for Update"
                                                                            maxLength="500" placeholder="Type here.." />
                                                                    </td>
                                                                    <td width="40%">
                                                                        <Field name="ArchiveDetails"
                                                                            type="checkbox"
                                                                            component={ReduxCheckboxElement}
                                                                            label="Archive Record"
                                                                            onChange={onArchiveDetailsChange}
                                                                        />
                                                                        <p style={{ fontSize: '11px' }}>Once archived, the record will no longer appear in the officer history details after saving</p>
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </Fragment>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
                <CustomConfirmModal
                    className="confirm-box"
                    data-testid="confirm-box"
                    open={this.state.isShowOfficerTitleArchievePopup}
                    header="Confirmation"
                    closeModal="true"
                    content={(
                        <>
                            <p className="txtCenter">Once archived, the record will no longer appear in the officer history details after saving.</p>
                            <p className="txtCenter">Do you want to archive this record?</p>
                        </>
                    )}
                    onCancel={onCancelBtnArchivePopup}
                    onConfirm={onConfirmBtnArchivePopup}
                    size="tiny"
                    cancelButton="No"
                    confirmButton="Yes"
                />
            </Fragment>
        )
    }
}

const validate = (values, props) => {
    let errors = {};
    let { CommitteeJoinDate } = props?.memberCommitteeDetails;

    if (!values.ArchiveDetails) {
        if (!values?.OfficerAppointedDate) {
            errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '8132.text');
        }
        else if (values?.OfficerAppointedDate &&
            !utilCommon.checkIfDateValid(values?.OfficerAppointedDate, 'MM/DD/YYYY')) {
            errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '3003.text');
        }
        else if (values?.OfficerAppointedDate && (utilCommon.compareDates(values?.OfficerAppointedDate, utilCommon.formatDateToMMDDYYYY(), true))) {
            errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '3084.text');
        }
        else if (values?.OfficerAppointedDate && (!utilCommon.compareDates(values?.OfficerAppointedDate, utilCommon.formatDateToMMDDYYYY(utilCommon.MinDate), true))) {
            errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '4021.text');
        }
        else if (values?.OfficerAppointedDate && utilCommon.compareDates(CommitteeJoinDate, values?.OfficerAppointedDate, true)) {
            errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '8191.text');
        }
        else if (values?.OfficerAppointedDate && props.previousOfficerEndDate
            && utilCommon.compareDates(props.previousOfficerEndDate, values?.OfficerAppointedDate, true)) {
            errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '8188.text');
        }
        else if (values?.OfficerAppointedDate && props.nextOfficerAppointedDate
            && utilCommon.compareDates(values?.OfficerAppointedDate, props.nextOfficerAppointedDate, true)) {
            errors.OfficerAppointedDate = utilCommon.getMessage(props.messageCodes, '8189.text');
        }
        if (!values?.OfficerEndDate && props.currentOfficerEndDate) {
            errors.OfficerEndDate = utilCommon.getMessage(props.messageCodes, '8186.text');
        }        
        else if (values?.OfficerEndDate &&
            !utilCommon.checkIfDateValid(values?.OfficerEndDate, 'MM/DD/YYYY')) {
            errors.OfficerEndDate = utilCommon.getMessage(props.messageCodes, '3005.text');
        }        
        else if (values?.OfficerEndDate && (utilCommon.compareDates(values?.OfficerEndDate, utilCommon.formatDateToMMDDYYYY(), true))) {
            errors.OfficerEndDate = utilCommon.getMessage(props.messageCodes, '8185.text');
        }        
        else if (values?.OfficerEndDate && (!utilCommon.compareDates(values?.OfficerEndDate, utilCommon.formatDateToMMDDYYYY(utilCommon.MinDate), true))) {
            errors.OfficerEndDate = utilCommon.getMessage(props.messageCodes, '4021.text');
        }
        else if (values?.OfficerAppointedDate && values?.OfficerEndDate
            && utilCommon.compareDates(values?.OfficerAppointedDate, values?.OfficerEndDate, true)) {
            errors.OfficerEndDate = utilCommon.getMessage(props.messageCodes, '8190.text');
        }
    }
    if (!values?.updateReason?.trim()) {
        errors.updateReason = utilCommon.getMessage(props.messageCodes, '8121.text');
    }
    return errors;
}

export default (reduxForm({
    form: 'OfficerTitleHistoryForm',
    validate
})(MemberCommitteeOfficerTitleHistoryModal));
